import { render, staticRenderFns } from "./Synopsis.vue?vue&type=template&id=36b151e9&scoped=true&"
import script from "./Synopsis.vue?vue&type=script&lang=js&"
export * from "./Synopsis.vue?vue&type=script&lang=js&"
import style0 from "./Synopsis.vue?vue&type=style&index=0&id=36b151e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b151e9",
  null
  
)

export default component.exports